export default "__VITE_ASSET__38879e3e__"